import { ChevronLeft, ChevronRight } from "lucide-react";
import { FormDropdown } from "../FormDropdown/FormDropdown";
import "../CreateRequestModal/CreateRequestModal.scss";
import "./RequestTablePagination.scss";

const PAGE_SIZE_OPTIONS = [
  { value: "5", label: "5" },
  { value: "10", label: "10" },
  { value: "20", label: "20" },
  { value: "50", label: "50" },
] as const;

interface RequestTablePaginationProps {
  page: number;
  totalPages: number;
  pageSize: number;
  canGoNext: boolean;
  onPageChange: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
  showPageSizeSelect?: boolean;
}

export const RequestTablePagination = ({
  page,
  totalPages,
  pageSize,
  canGoNext,
  onPageChange,
  onPageSizeChange,
  showPageSizeSelect = true,
}: RequestTablePaginationProps) => (
  <div
    className={`request-table-pagination${showPageSizeSelect ? "" : " request-table-pagination--pages-only"}`}
  >
    {showPageSizeSelect && onPageSizeChange && (
      <div className="request-table-page-size">
        <span>Кол-во:</span>
        <FormDropdown
          className="request-table-page-size-select"
          value={String(pageSize)}
          options={[...PAGE_SIZE_OPTIONS]}
          onChange={(value) => {
            onPageSizeChange(Number(value));
            onPageChange(0);
          }}
        />
      </div>
    )}

    <div className="request-table-page-controls">
      <span className="request-table-page-info">
        {page + 1} / {Math.max(1, totalPages)}
      </span>
      <button
        type="button"
        className="request-table-page-btn"
        disabled={page === 0}
        onClick={() => onPageChange(page - 1)}
      >
        <ChevronLeft size={20} />
      </button>
      <button
        type="button"
        className="request-table-page-btn"
        disabled={!canGoNext}
        onClick={() => onPageChange(page + 1)}
      >
        <ChevronRight size={20} />
      </button>
    </div>
  </div>
);
